import { isOnline } from "@openmrs/esm-utils";
export function checkStatus(online = true, offline = false) {
    return checkStatusFor(isOnline(), online, offline);
}
export function checkStatusFor(status, online = true, offline = false) {
    return Boolean(status ? online : offline);
}
